var _rect, _path, _path2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 24,
    viewBox: "0 0 86 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1912056528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE5\xB0\x8F\xE9\xA6\x99\xE9\xA3\x8Elogo",
    clipPath: "url(#clip0_238_10437)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1",
    width: 24,
    height: 24,
    rx: 5.25,
    fill: "#141422"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 3673 (Stroke)",
    d: "M19.5921 5.13281L14.7151 10.2468L18.6509 13.4938C19.9047 14.5282 19.9694 16.4268 18.7891 17.5441C17.8681 18.416 16.4649 18.5308 15.4144 17.8202L13.9007 16.7962L11.9377 18.8672H4.57586L8.91104 14.264L5.34012 11.2202C4.16164 10.2157 4.02595 8.44394 5.03772 7.27169C6.03703 6.11387 7.78192 5.97573 8.95098 6.96188L9.76204 7.64603L12.3295 5.13281H19.5921ZM9.85172 15.0428L7.39776 17.6484H11.4137L13.7273 15.2075L16.0973 16.8108C16.6744 17.2012 17.4453 17.1381 17.9513 16.6591C18.5997 16.0452 18.5641 15.0022 17.8754 14.434L13.8493 11.1125L9.85172 15.0428ZM9.82297 9.29187L8.16516 7.89345C7.50649 7.33783 6.52337 7.41567 5.96034 8.06802C5.39029 8.72849 5.46674 9.72674 6.13072 10.2927L9.77756 13.4011L13.7718 9.47008L16.7458 6.35156H12.8267L9.82297 9.29187Z",
    fill: "url(#paint0_linear_238_10437)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_238_10437",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 5,
    width: 16,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 3673 (Stroke)_2",
    d: "M19.5921 5.13281L14.7151 10.2468L18.6509 13.4938C19.9047 14.5282 19.9694 16.4268 18.7891 17.5441C17.8681 18.416 16.4649 18.5308 15.4144 17.8202L13.9007 16.7962L11.9377 18.8672H4.57586L8.91104 14.264L5.34012 11.2202C4.16164 10.2157 4.02595 8.44394 5.03772 7.27169C6.03703 6.11387 7.78192 5.97573 8.95098 6.96188L9.76204 7.64603L12.3295 5.13281H19.5921ZM9.85172 15.0428L7.39776 17.6484H11.4137L13.7273 15.2075L16.0973 16.8108C16.6744 17.2012 17.4453 17.1381 17.9513 16.6591C18.5997 16.0452 18.5641 15.0022 17.8754 14.434L13.8493 11.1125L9.85172 15.0428ZM9.82297 9.29187L8.16516 7.89345C7.50649 7.33783 6.52337 7.41567 5.96034 8.06802C5.39029 8.72849 5.46674 9.72674 6.13072 10.2927L9.77756 13.4011L13.7718 9.47008L16.7458 6.35156H12.8267L9.82297 9.29187Z",
    fill: "url(#paint1_linear_238_10437)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_238_10437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34625816",
    d: "M8.88262 14.2389L10.7165 15.8427L8.05883 17.6352L6.5054 16.4923L8.88262 14.2389Z",
    fill: "url(#paint2_linear_238_10437)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34625817",
    d: "M13.2002 8.956L15.0528 10.5346L17.398 7.78778L15.5426 6.20692L13.2002 8.956Z",
    fill: "url(#paint3_linear_238_10437)"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group 1912056511"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xB0\x8F",
    d: "M34.8915 9.63282L35.3653 2.85718H38.6722L37.7589 15.9175C37.6335 17.7112 37.3993 18.5267 36.9909 19.2992C36.5947 20.0848 35.9623 20.5889 35.0936 20.8115C34.2249 21.034 33.2465 21.1453 31.3696 21.1453L31.6462 17.1903C32.4993 17.1903 33.1261 16.9546 33.5265 16.4833C33.941 15.9988 34.2328 15.2984 34.4019 14.3818C34.5719 13.4522 34.7569 11.5575 34.8915 9.63282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.2648 5.76912L63.0761 5.78096C61.2237 5.89715 59.6329 5.99464 57.7093 6.05529L57.6361 7.10164H65.0968L64.8981 9.94226H61.8685C62.5067 10.9077 63.4436 11.639 64.7925 12.1345L64.9085 12.1771L65.0193 15.6404L64.7319 15.5426C63.8885 15.2555 62.9115 14.6834 62.1924 14.2233L61.9033 18.3574C61.7926 19.9409 60.4158 21.2247 58.8285 21.2247H48.0666L48.5571 14.2106C47.7341 14.6377 46.5858 15.0294 45.7249 15.3092L45.4059 15.4128L46.1331 12.1747L46.2482 12.1345C47.6664 11.639 48.7056 10.9077 49.4788 9.94226H46.4492L46.6478 7.10164H54.3184L54.3852 6.14561C52.5801 6.18278 50.789 6.20144 48.8364 6.20144H48.6359L48.8373 3.3208H49.0378C54.1475 3.3208 58.6448 3.1809 63.2531 2.88114L63.4678 2.86719L63.2648 5.76912ZM51.2349 18.6448H58.8953L58.9582 17.7446H51.2979L51.2349 18.6448ZM51.4727 15.2441H59.1331L59.196 14.3439H51.5357L51.4727 15.2441ZM52.7784 9.94226C52.4446 10.6044 52.0374 11.2145 51.5671 11.7827H53.9911L54.1198 9.94226H52.7784ZM57.3088 11.7827H59.5228C59.132 11.2145 58.8101 10.6044 58.5689 9.94226H57.4375L57.3088 11.7827Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1912056515"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M81.1807 7.69238L74.7441 14.1289L73.7432 13.127L71.9805 11.3652C71.4278 10.8123 71.4281 9.91541 71.9805 9.3623C72.5336 8.80918 73.4313 8.80918 73.9844 9.3623L74.7441 10.1221L77.3467 7.51855H81.0068L81.1807 7.69238Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    d: "M77.3018 11.0542L79.0645 12.8159C79.6172 13.3689 79.6172 14.2658 79.0645 14.8188C78.5113 15.372 77.6137 15.372 77.0605 14.8188L76.3008 14.0591L73.2598 17.1001H70.4746L69.8643 16.4888L76.3008 10.0522L77.3018 11.0542Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    d: "M84.1388 2.89603C84.0185 4.00267 83.8843 5.0936 83.7909 6.17852C83.6189 9.1777 83.0477 15.9484 83.0219 16.6205C82.9873 17.52 83.9213 17.8198 84.6208 17.8198V21.2842C84.6208 21.2842 79.236 21.2842 79.5574 15.821C79.7 13.3972 80.1624 8.80374 80.3102 6.36936L71.8732 6.30987C71.6533 8.74059 71.0222 13.4215 70.8063 15.821C70.24 22.1133 65.2432 21.2842 65.2432 21.2842C65.2442 21.278 65.7428 18.2524 65.7428 17.8198C66.4424 17.8198 67.2086 17.5866 67.3418 16.6205C67.3939 15.9959 68.1574 9.08565 68.4766 6.10255C68.6023 4.92764 68.7202 4.11905 68.7202 2.896C73.9793 2.896 78.8797 2.89603 84.1388 2.89603Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_3",
    d: "M33.3156 6.85303C33.3156 6.85349 32.9828 11.0457 32.6832 13.67C32.3209 16.8438 29.1238 18.3361 27.9281 18.7869L27.8221 14.8314C28.3645 14.6418 29.1469 14.1854 29.3853 13.1052C29.498 12.3744 29.8511 6.85333 29.8512 6.85303H33.3156Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_4",
    d: "M43.501 6.85303C43.5011 6.87069 43.5283 13.072 43.6025 13.8052C43.744 14.647 44.2356 15.1101 44.6973 15.3638L44.3828 19.3374C43.0278 18.7451 40.4531 17.2493 40.2754 14.3716C40.1136 11.7474 40.0364 6.86745 40.0361 6.85303H43.501Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_238_10437",
    x1: 8.4923,
    y1: 9.56851,
    x2: 16.4775,
    y2: 17.7231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_238_10437",
    x1: 8.4923,
    y1: 9.56851,
    x2: 16.4775,
    y2: 17.7231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_238_10437",
    x1: 9.30099,
    y1: 14.6064,
    x2: 7.17791,
    y2: 17.0374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16172A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16172A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_238_10437",
    x1: 14.1331,
    y1: 9.74035,
    x2: 16.4755,
    y2: 6.99127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16172A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16172A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_238_10437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fe7c08bcd8e27d5e4be5155ece94c065.svg";
export { ForwardRef as ReactComponent };